import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  imports: [],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent implements OnInit {
  errorMessage: string = 'An unexpected error occurred. Please try again later.';
  errorCode: number = 404;

  constructor() {}

  ngOnInit(): void {
    // You can fetch the error code and message from a service or route parameters if needed
    // For now, we are using static values
  }

}
